import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-login',
  imports: [],
  templateUrl: './icon-login.html',
  standalone: true,
  styleUrl: './icon-login.css'
})
export class IconLogin {
  @Input() color: string = 'white';
  @Input() size: string = '24px';
}
